/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { ShortLinkTargetScenarioId } from './shortLinkTargetScenarioId'

export interface ShortLinkTarget {
  /**
   * プレイリスト文脈付きの場合のプレイリストID @example "cmmd80xkh000n0w01dxd7hfbv"
   * @nullable
   */
  scenarioId: ShortLinkTargetScenarioId
  /** リダイレクト先の動画ID @example "cmmd80xkh000n0w01dxd7hfbv" */
  videoId: Cuid
  /** リダイレクト先動画の所属テナントID @example "cl4ti57va00006eqc59p24zmp" */
  tenantId: Cuid
}
